// extracted by mini-css-extract-plugin
module.exports = {"versions":"_2kv_mH2nfk","radio-group-solid":"D_84fABMVw","section":"_1b6syFpwk5","form":"_2VrmHqtpBS","btn":"_2EBdolbl8y","add-btn":"_3r_T2BRfct"};